import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DatepickerService {
  public startView: 'month' | 'year' | 'multi-year' = 'month';
}
